import { render, staticRenderFns } from "./ReporteCobradoXFecha.vue?vue&type=template&id=4e20130c&scoped=true"
import script from "./ReporteCobradoXFecha.vue?vue&type=script&lang=js"
export * from "./ReporteCobradoXFecha.vue?vue&type=script&lang=js"
import style0 from "./ReporteCobradoXFecha.vue?vue&type=style&index=0&id=4e20130c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20130c",
  null
  
)

export default component.exports